export default "__VITE_ASSET__jwqn9LFR__"